module.exports = __webpack_public_path__ + "static/studio-5-ef5c30ea69b7ad740ee6221782c73741.jpg";